// extracted by mini-css-extract-plugin
export default {"listGroup":"CompetencyHexagonList_listGroup__kZVhs","listGroupIndent":"CompetencyHexagonList_listGroupIndent__rQwqL"};